import { makeStyles } from '@mui/styles';
import { Colors, FontWeight } from '../../assets/styles';
import { Theme } from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => ({
  header: {
    backgroundColor: Colors.White,
    borderBottom: `1px solid ${Colors.Gray3}`,
    height: 71,
    display: 'flex',
    alignItems: 'center',
    padding: '7px 29px 7px 0px',
  },
  dashboardHeader: {
    justifyContent: 'flex-end',
    padding: '7px 29px',
    display: 'flex',
  },
  content: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  navigation: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    '& $navBtn:not(:last-child):after': {
      content: '""',
      position: 'absolute',
      backgroundColor: Colors.Gray5,
      width: 2,
      height: 38,
      right: '-7px',
    },
  },
  homeBtnWrapper: {
    margin: '-7px 0',
    padding: '7px 8px',
    borderRight: `2px solid ${Colors.Gray5}`,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    color: '#008DCD',
    fontWeight: 'normal',
  },
  homeBtn: {
    padding: '8px 12px !important',
    color: `${Colors.Blue1} !important`,
    fontSize: '15px !important',
    lineHeight: '15px !important',
    borderRadius: '4px',
    '& svg': {
      transform: 'scale(-1, 1)',
      marginRight: '6px',
    },
  },
  saveAndExitTitle: {
    paddingBottom: 10,
  },
  navBtn: {
    '&.MuiButton-root':{
      fontSize: '15px !important',
      fontWeight: `${FontWeight.Regular} !important`,
      color: `${Colors.Blue1} !important`,
      textTransform: 'none',
      margin: '0 7px  !important',
    }
  },
  backBtn: {
    paddingLeft: 0,
  },
  amountWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  totalSavingsText: {
    fontSize: '13px !important',
    fontWeight: `${FontWeight.Bold} !important`,
    color: `${Colors.Gray} !important`,
    textTransform: 'uppercase',
    paddingRight: '10px !important',
  },
  reportName: {
    fontSize: '20px !important',
    fontWeight: `${FontWeight.Bold} !important`,
    marginRight: '30px !important',
  },
  totalSavingsAmount: {
    fontSize: '28px !important',
    fontWeight: `${FontWeight.Bold} !important`,
  },
  totalSavingsAmountPositive: {
    color: `${Colors.Green2} !important`
  },
  calculationsNameInput: {
    width: '500px !important',
  },
}));

export default useStyles;